<template>
  <path
    d="M19 3.00018H5C3.9 3.00018 3 3.90018 3 5.00018V19.0002C3 20.1002 3.9 21.0002 5 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V5.00018C21 3.90018 20.1 3.00018 19 3.00018ZM14 9.00018H11V11.0002H14C14.55 11.0002 15 11.4502 15 12.0002C15 12.5502 14.55 13.0002 14 13.0002H11V15.0002H14C14.55 15.0002 15 15.4502 15 16.0002C15 16.5502 14.55 17.0002 14 17.0002H10C9.45 17.0002 9 16.5502 9 16.0002V8.00018C9 7.45018 9.45 7.00018 10 7.00018H14C14.55 7.00018 15 7.45018 15 8.00018C15 8.55018 14.55 9.00018 14 9.00018Z"
  />
</template>
